









import { Component, Watch, Vue } from 'vue-property-decorator'

import Body from '@/views/layouts/_partials/Body.vue'
import Footer from '@/views/layouts/_partials/Footer.vue'
import Header from '@/views/layouts/_partials/Header.vue'
import Nav from '@/views/layouts/_partials/Nav.vue'
import { api } from '@sfs-projects/sfs-fc-api-sdk'


@Component({
  name: 'MasterLayout',
  components: {
    Body, Footer, Header, Nav
  }
})
export default class MasterLayout extends Vue {
  isAuth = false;

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    api.Auth.isAuthenticated().then((checked) => {
      this.isAuth = checked;
    });
  }
}
